import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// this is used to create scrollbars on windows devices like the ones from apple devices
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import Sidebar from "components/Sidebar/Sidebar.jsx";
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Notifications from "components/Notifications/Notifications.jsx";

// dinamically create dashboard routes
import dashboardRoutes from "routes/dashboard.jsx";

import { bindActionCreators } from 'redux';
import { connect } from "react-redux"
import { showSuccessfulMessage, setLoggedInMessage } from "reducers/application/applicationActions"
import Auth from "../../utils/Auth/Auth";

var ps;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preLoaderClasses: "pre-loader "
    };
  }

  componentWillReceiveProps(nextProps) {
    console.log("Dashboard : ", nextProps);
    if (nextProps.dashboard) {
      console.log("Dashboard : ", nextProps);
      this.refs.mainPanel.scrollTop = 0;
      if (nextProps.dashboard.showLoading == true) {
        this.setState({ preLoaderClasses: "pre-loader pre-loader__show" });
      } else {
        this.setState({ preLoaderClasses: "pre-loader pre-loader__hide" });
      }
    }
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel);
    }
    this.handleShowLoggedInMessage();
  }

  handleShowLoggedInMessage() {
    console.log("showLoggedInMessage", this.props.showLoggedInMessage);
    if (this.props.showLoggedInMessage) {
      setTimeout(() => {
        const user = new Auth().getUser();
        this.props.dispatch(showSuccessfulMessage("Bienvenido " + user.completeName));
      }, 350);
      this.props.dispatch(setLoggedInMessage(false));
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }

  componentDidUpdate(e) {
    if (navigator.platform.indexOf("Win") > -1) {
      setTimeout(() => {
        ps.update();
      }, 350);
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
    if (
      window.innerWidth < 993 &&
      e.history.action === "PUSH" &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }

  componentWillMount() {
    if (document.documentElement.className.indexOf("nav-open") !== -1) {
      document.documentElement.classList.toggle("nav-open");
    }
  }

  render() {


    return (
      <div className="wrapper">
        <Notifications />
        <Sidebar {...this.props} />
        <div
          className={
            "main-panel" +
            (this.props.location.pathname === "/maps/full-screen-maps"
              ? " main-panel-maps"
              : "")
          }
          ref="mainPanel"
        >
          <Header {...this.props} />
          <Switch>
            {dashboardRoutes.map((prop, key) => {
              if (prop.collapse) {
                return prop.views.map((prop, key) => {
                  if (prop.name === "Notifications") {
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <prop.component
                            {...routeProps}
                          //handleClick={this.handleNotificationClick}
                          />
                        )}
                      />
                    );
                  } else {
                    return (
                      <Route
                        path={prop.path}
                        component={prop.component}
                        key={key}
                      />
                    );
                  }
                });
              } else {
                if (prop.redirect)
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                else
                  return (
                    <Route
                      path={prop.path}
                      component={prop.component}
                      key={key}
                    />
                  );
              }
            })}
          </Switch>
          <Footer fluid />
        </div>

        <div className={this.state.preLoaderClasses}></div>

      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    successfulMessage: state.application.successfulMessage,
    showLoggedInMessage: state.application.showLoggedInMessage,
    dashboard: state.application.dashboard
  };
}

function mapDispatchToProps(dispatch) {
  let actions = bindActionCreators({
    showSuccessfulMessage: showSuccessfulMessage,
    setLoggedInMessage: setLoggedInMessage
  });
  return { ...actions, dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx